export default __webpack_public_path__ + "static/media/failedgif.ed302c2d.gif";